import { Button, Typography } from 'antd';
import styled from 'styled-components';

export const ModalHeader = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export const CloseButton = styled(Button)`
	color: #d2d2d2;
`;

export const ModalContainer = styled.div<{ $display: boolean }>`
	border-radius: 16px 16px 0 0;
	background-color: white;
	padding: 1rem;
	padding-top: 0.5rem;
	position: fixed;
	bottom: 0;
	left: 0;
	max-height: calc(100vh - 100px);
	overflow: hidden;

	transition: translate 0.2s ease-in-out;

	translate: ${({ $display }) => ($display ? `0 0` : '0 100%')};
	width: 100%;

	overflow-y: auto;
	overscroll-behavior: contain;
`;

export const ModalWrapper = styled.div`
	position: fixed;
	z-index: 1000;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.5);
`;

export const FooterButton = styled(Button)`
	flex: 1;
`;

export const ModalFooter = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
	padding-top: 1rem;
`;

export const ModalTitle = styled(Typography.Title)`
	margin: 0.5rem 0;
	margin-top: 0;
`;
